import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../HomePage/HomePageStyles.css";
import {
  CONST_CONF,
  CONST_LABELS,
  CONST_TERMS,
  CONST_LABELS_LNG,
} from "../Commons";

const SuccessPage: React.FC = () => {
  //  <script>
  //       gtag("event", "conversion", {
  //         send_to: "AW-/",
  //       });
  //     </script>
  const congrImg = require("../../assets/images/congrats.png");
  const bannerImg = require("../../assets/images/banner-0.jpg");
  const successImg = require("../../assets/images/success_image.png");
  const submitConversation = () => {
    //@ts-ignore
    gtag("event", "conversion", {
      send_to: "AW",
    });
  };
  useEffect(() => {
    submitConversation();
  }, []);
  
  const location = useLocation() //To received cgurl from homepage

  let redirectUrl:string
  
  if (location.state !== null) {
    redirectUrl = location.state.id
  } else {
    redirectUrl = String(CONST_CONF.get("URL_REDIRECT_SUCCESS"))
  }
  
  if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("the redirectUrl is", redirectUrl)

   setTimeout(() => {
      window.location.replace(String(redirectUrl))
    }
  , 5000)
  
  

  return (
    <div className="registration">
      <div className="section-block">
        <div className="banner">
          <img src={bannerImg} alt="" />
        </div>
      </div>
      <div className="">
        {/* </form> */}
        <div className="section">
          {/* <img src={congrImg} alt="" /> */}
          <img className="success-img pulse" src={successImg} alt="" />
        </div>
        <div className="info-text-wrapper">
          <div >
            <div className="success-text" style={{ color: "rgba(45, 244, 121, 1)", textAlign: "center" }}>
              SUCCESS
            </div>
          </div>
          <p className="footer-text">
            <div
              dangerouslySetInnerHTML={{
                __html: String(CONST_TERMS.get("LBL_SUCCESSFOOTER")),
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
